module.exports = __webpack_public_path__ + "static/CareRing-scrn-be20c3c7919f14900346c869dcc51102.png";